import AurVideoPlayer from '../../../common/aur-video-player/AurVideoPlayer';

const VideoController = () => {
  return (
    <AurVideoPlayer
      src="https://download.blender.org/peach/bigbuckbunny_movies/BigBuckBunny_320x180.mp4"
      poster="https://images.pexels.com/photos/34234384/pexels-photo-34234384.jpeg"
    />
  );
};

export default VideoController;
